import { render } from "./Qualifiers.vue?vue&type=template&id=0a23c9cb"
import script from "./Qualifiers.vue?vue&type=script&lang=js"
export * from "./Qualifiers.vue?vue&type=script&lang=js"
script.render = render

export default script